<p class="mb-0">
    <button data-cy-close-form class="btn btn-back" (click)="closeForm()" title="{{ buttonTooltip | i18next: { targetPage: buttonTitle } }}">
        <svg class="btn-icon-left icon-20-chevron-left"><use xlink:href="images/s7-icons-20.svg#chevron-left" /></svg>
        {{ buttonTitle }}
    </button>
</p>
